module.exports = __webpack_public_path__ + "img/social_sharing.dce01f3a.svg";